<fo-equipment-form
  typeFirst
  [showSectionIndex]="false"
  (valueChange)="onValueChange($event)"
  [initialValue]="initialValue"
  [editableCompany]="canAssignCompany() || lockCompany"
  [attachments]="attachments.displayedAttachments"
  (newAttachmentsChange)="attachments.update($event)"
  [assetTypeChoices]="(assetTypes$ | async) ?? []"
  [parentChoices$]="parents$"
  [locationChoices$]="locations$"
  [categoryChoices$]="categories$"
/>
